export default [
  {
    path: "/goodStuffApplicationList",
    name: "申请列表",
    component: () => import("../views/goodStuff/applicationList.vue"),
  },
  {
    path: "/goodStuffList",
    name: "靓货清单",
    component: () => import("../views/goodStuff/list.vue"),
  },
];
